<div class="news-item">
  <img class="news-item-image" (click)="itemClick()" src="{{item?.boxImage}}" alt="An image accompanying the article" />
  <div class="news-item-title" (click)="itemClick()">{{item?.title}}</div>
  <hr class="news-item-separator" />
  <div class="news-item-footer">
    <div class="news-item-footer-date">{{item?.publishDate|datePreference}}</div>    
  </div>
</div>

<ng-template #popuptemplate let-modal>
  <app-news-item-popup [imageSrc]="item?.boxImage" [title]="item?.title" [content]="item?.content"></app-news-item-popup>
</ng-template>
